import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Spinner,
} from "@chakra-ui/react";

const PreviewModal = ({ isOpen, onClose, isLoading, previewContent }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent maxWidth="95vw">
        <ModalHeader>Campaign Preview</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <Spinner />
          ) : (
            <div
              style={{ maxWidth: "100%", overflowX: "auto" }}
              dangerouslySetInnerHTML={previewContent}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PreviewModal;
